import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StartRoutingModule } from './start-routing.module';
import { StartComponent } from './start.component';

@NgModule({
  imports: [
    CommonModule,
    StartRoutingModule
  ],
  declarations: [
  	StartComponent
  ]
})
export class ButtonModule { }



// WEBPACK FOOTER //
// ./src/app/view/start/start.module.ts